import { ADD_RETURN, CREATE_RETURN_SUCCESS, CLEAR_RETURN, CLEAR_ALL_RETURNS } from '../constants/ActionTypes'

export default function returnOrder(state = undefined, action) {
    switch (action.type) {
        case ADD_RETURN: {
            const { orderNumber, returnLine, orderItem } = action.payload
            const { primeLineNo, partNumber, quantity, returnOrExchange, selectedProductColour } = orderItem
            const returnShippingMethod = orderItem.shippingMethodName

            if (state && state.returnLines) {
                const filteredReturnLines = state.returnLines.filter(
                    (returnLine) => returnLine.lineNumber !== orderItem.primeLineNo
                )
                return {
                    orderNumber: orderNumber,
                    returnShippingMethod,
                    returnLines: [
                        ...filteredReturnLines,
                        {
                            ...returnLine,
                            lineNumber: primeLineNo,
                            partNumber,
                            quantity,
                            returnOrExchange,
                            selectedProductColour,
                        },
                    ],
                }
            } else {
                const returnLines = [
                    {
                        ...returnLine,
                        lineNumber: primeLineNo,
                        partNumber,
                        quantity,
                        returnOrExchange,
                        selectedProductColour,
                    },
                ]
                return { orderNumber, returnLines, returnShippingMethod }
            }
        }
        case CLEAR_RETURN: {
            const { returnLines } = state
            if (returnLines && returnLines.length < 2) {
                return undefined
            } else {
                return {
                    ...state,
                    returnLines: returnLines.filter((returnLine) => returnLine.lineNumber !== action.item.primeLineNo),
                }
            }
        }
        case CLEAR_ALL_RETURNS:
            return undefined
        case CREATE_RETURN_SUCCESS:
        default:
            return state
    }
}
